import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import { StaticImage } from 'gatsby-plugin-image'

const UploadHealthData = () => {
  const { t } = useTranslation()
  return (
    <div className="health_data_upload">
      <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 et-1">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12 col-sm-8 col-md-8 col-lg-8">
            <h1 className="font-weight-semibold hero-heading mt-5 no-br">
              <Trans>
                Lab Report <br />
                Upload & Workforce <br />
                Health Insights
              </Trans>
            </h1>
            <p className="hero-para font-weight-semibold no-br">
              <Trans>
                Turn employee health data into <br /> actionable insights
              </Trans>
            </p>
            <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
              <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                <Trans>Book a Demo</Trans>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="position-relative pl-0 pr-0">
        <div className="">
          <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
            <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
              <div className="col-12 col-md-6">
                <div className="col-12">
                  <h2 className="font-weight-semibold py-2 section-heading">
                    <Trans>What is it ?</Trans>
                  </h2>
                  <p className="section-para font-weight-normal">
                    <Trans>
                      The Lab Report Upload & Workforce Health Insights feature lets HRs securely upload and analyze
                      organizational health data with AI.
                      <br />
                      <br />
                      It provides insights, identifies risk patterns, and enables data-driven decisions while ensuring
                      privacy.
                    </Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 cta-img">
                <div className="d-flex justify-content-center">
                  <img
                    className="img-responsive"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_500/v1771324525/VantageFit/2026/hlth33`
                    )}
                    fetchPriority="high"
                    alt="Connect, Share, Inspire!"
                    width="500"
                    height="604"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
            <div className="container custom_container d-flex flex-column  m-d-block justify-content-center align-items-center">
              <div className="col-12">
                <h2 className="font-weight-semibold py-2 text-center section-heading no-br">
                  <Trans>How it Works</Trans>
                </h2>
              </div>
              <div className="col-12">
                <div className="col-12 d-flex justify-content-center py-5 mb-5 mb-md-0 py-md-5">
                  <div className="steps_container">
                    <button className="step_tab" style={{ color: '#F15162' }}>
                      <Trans>Secure Uploads</Trans>
                    </button>
                    <div className="step_connector" />
                    <button className="step_tab" style={{ color: '#08C8AD' }}>
                      <Trans>Employee Convenience</Trans>
                    </button>
                    <div className="step_connector" />
                    <button className="step_tab" style={{ color: '#FF9D57' }}>
                      <Trans>AI-Powered Analysis</Trans>
                    </button>
                  </div>
                </div>

                <div className="col-12">
                  <div className="row g-0" style={{ maxWidth: 1150 }}>
                    <div className="col-12 col-md-4">
                      <img
                        src={t(
                          `https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_370/v1771410835/VantageFit/2026/Group_1500`
                        )}
                        width="370"
                        height="437"
                        alt="ft1"
                        loading="lazy"
                        decoding="async"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <img
                        src={t(
                          `https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_370/v1771410835/VantageFit/2026/Group_1498`
                        )}
                        width="370"
                        height="437"
                        alt="ft 2"
                        loading="lazy"
                        decoding="async"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <img
                        src={t(
                          `https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_370/v1771410835/VantageFit/2026/Group_1499`
                        )}
                        width="370"
                        height="437"
                        alt="ft 3"
                        loading="lazy"
                        decoding="async"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
            <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
              <div className="col-12 col-md-6">
                <div className="col-12">
                  <h2 className="font-weight-semibold py-2 section-heading">
                    <Trans>
                      Your Workforce <br /> Wellness Snapshot
                    </Trans>
                  </h2>
                  <p className="section-para font-weight-normal">
                    <Trans>
                      HR admins can access aggregated health data insights through an intuitive Workforce Health
                      Dashboard, including:
                    </Trans>
                  </p>
                  <div>
                    <ul
                      className="greenTick position-relative"
                      style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}
                    >
                      <p className="text-white">
                        <Trans>
                          <span style={{ fontWeight: '600', color: '#08C8AD' }}>Population Health Overview:</span>{' '}
                          Percentage of employees across low, moderate, and high-risk categories.
                        </Trans>
                      </p>
                    </ul>
                    <ul
                      className="greenTick position-relative"
                      style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}
                    >
                      <p className="text-white">
                        <Trans>
                          <span style={{ fontWeight: '600', color: '#08C8AD' }}>Trends Over Time:</span> Graphs showing
                          how risks evolve after wellness initiatives.
                        </Trans>
                      </p>
                    </ul>
                    <ul
                      className="greenTick position-relative"
                      style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}
                    >
                      <p className="text-white">
                        <Trans>
                          <span style={{ fontWeight: '600', color: '#08C8AD' }}>Key Deficiency Insights:</span> Data on
                          Vitamin D, Iron, cholesterol, and more.
                        </Trans>
                      </p>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 cta-img">
                <div className="d-flex justify-content-center">
                  <img
                    className="img-responsive"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_500/v1771391883/VantageFit/2026/Group_1476`
                    )}
                    loading="lazy"
                    alt="Celebrate Every Milestone!"
                    width="500"
                    height="561"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
          <div className="container custom_container d-flex flex-column  m-d-block justify-content-center align-items-center">
            <div className="col-12">
              <h2 className="font-weight-semibold py-2 text-center section-heading no-br">
                <Trans>Privacy You Can Trust</Trans>
              </h2>
              <p className="sub-para font-weight-normal text-center mb-5 text-white">
                <Trans>With these health insights, HRs can design targeted wellness programs based on real data.</Trans>
              </p>
            </div>
            <div
              className="row mt-5 rounded-lg"
              style={{
                background:
                  'linear-gradient(133.25deg, rgba(65, 216, 180, 0.1) 0%, rgba(117, 115, 215, 0.082588) 52.64%, rgba(196, 196, 196, 0.0718695) 97.13%)',
                backdropFilter: 'blur(50.4900016784668px)',
                boxShadow: '0px 20px 22px 1px #161C2372',
                padding: '0.4rem 2rem',
                border: '1px solid #FFFFFF33',
              }}
            >
              <div className="col-12 col-md-6 d-flex align-items-center">
                <p className="text-white text-center text-md-left mb-0 w-100 mt-3 mt-md-0" style={{ fontSize: 22 }}>
                  <Trans>Your data is safe with us</Trans>
                </p>
              </div>
              <div className="col-12 col-md-6 my-3 my-md-0">
                <picture>
                  {/* Large screens (≥768px) */}
                  <source
                    media="(min-width: 768px)"
                    srcSet="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_590/v1766414004/VantageFit/2025/Hipaa"
                    type="image/png"
                  />

                  {/* Mobile screens (<768px) */}
                  <source
                    srcSet="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_300/v1766414004/VantageFit/2025/Hipaa"
                    type="image/png"
                  />

                  <img
                    src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_590/v1766414004/VantageFit/2025/Hipaa"
                    alt="safe data logos"
                    loading="lazy"
                    width="590"
                    height="auto"
                    style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>

        <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
          <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
            <div className="col-12 col-md-6">
              <div className="col-12">
                <h2 className="font-weight-semibold py-2 section-heading">
                  <Trans>
                    Turning Insights <br /> into Action
                  </Trans>
                </h2>
                <p className="section-para font-weight-normal">
                  <Trans>
                    With these health insights, HRs can design targeted wellness programs based on real data.
                  </Trans>
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 cta-img">
              <div className="d-flex justify-content-center">
                <img
                  className="img-responsive"
                  src={t(
                    `https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_500/v1771394977/VantageFit/2026/Group_1490`
                  )}
                  loading="lazy"
                  alt="Milestone!"
                  width="500"
                  height="561"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
          <div className="container custom_container d-flex flex-column  m-d-block justify-content-center align-items-center">
            <div className="col-12">
              <h2 className="font-weight-semibold py-2 text-center section-heading no-br">
                <Trans>Key Benefits</Trans>
              </h2>
            </div>
            <div
              className="row mt-3 mt-md-5 rounded-lg p-3 p-md-5"
              style={{
                background: '#303740',
                backdropFilter: 'blur(50.4900016784668px)',
                boxShadow: '0px 20px 22px 1px #161C2372',
                border: '1px solid #FFFFFF33',
              }}
            >
              <div className="col-12 px-0">
                <picture>
                  {/* Large screens (≥768px) */}
                  <source
                    media="(min-width: 768px)"
                    srcSet="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_1030/v1771395245/VantageFit/2026/Element-4"
                    type="image/png"
                  />

                  {/* Mobile screens (<768px) */}
                  <source
                    srcSet="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_600/v1771395245/VantageFit/2026/Element-4"
                    type="image/png"
                  />

                  <img
                    src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_600/v1771395245/VantageFit/2026/Element-4"
                    alt="safe data logos"
                    loading="lazy"
                    width="590"
                    height="auto"
                    style={{ width: '100%', maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12">
            <h2 className="font-weight-semibold section-heading text-center no-br">
              <Trans>
                Unlock the Power of <br />
                Data-Driven Wellness Decisions
              </Trans>
            </h2>
            <p className="sub-para font-weight-normal text-center mb-5 text-white">
              <Trans>Turn reports into real impact with Vantage Fit</Trans>
            </p>
            <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
              <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                <Trans>Book a Demo</Trans>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default UploadHealthData
